<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Agenzia Sub-Agente' : 'Nuova Agenzia Sub-Agente' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-sub-agent-form [data]="data"></app-sub-agent-form>
</div>
